import * as React from 'react';
import {
  Button,
  DialogTitle,
  DialogActions,
  Divider,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { IconButtonStyle } from '../Modal/style';
import { Form } from '../projectlist/style';
import invitereportService from '../../services/invitereport.service';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '8px',
    borderBottom: `3px solid ${theme.palette.warning.main}`,
    borderLeft: `3px solid ${theme.palette.warning.main}`,
    padding: '15px 56px',
  },
  '& .MuiDialogTitle-root': {
    fontWeight: 600,
    fontSize: '24px',
  },
}));

export default function ScrollDialog({
  openDailog,
  tId,
  onOpen,
  setSnackbarData,
  reportType,
}) {
  const [userEmail, setUserEmail] = React.useState('');
  const [emailList, setEmailList] = React.useState([]);

  const addEmail = () => {
    if (userEmail && !emailList.includes(userEmail)) {
      setEmailList([...emailList, userEmail]);
      setUserEmail('');
    }
  };

  const removeEmail = (email) => {
    setEmailList(emailList.filter((e) => e !== email));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await invitereportService.inviteGuestForReport({
        email: emailList,
        testReportId: tId,
        reportType,
      });
      setSnackbarData({
        navigateText: '',
        severity: 'success',
        state: true,
        message: 'Invites sent successfully!',
      });
      onOpen(false);
    } catch (error) {
      setSnackbarData({
        navigateText: '',
        severity: 'error',
        state: true,
        message: error.data?.message || 'Error sending invites',
      });
    } finally {
      setUserEmail('');
      setEmailList([]);
    }
  };

  const onClose = () => {
    setUserEmail('');
    setEmailList([]);
    onOpen(false);
  };

  return (
    <StyledDialog open={openDailog} onClose={onClose}>
      <DialogTitle style={{ padding: '12px 0px' }}>Invite Report</DialogTitle>
      <Divider />
      <IconButtonStyle onClick={onClose}>
        <CloseIcon />
      </IconButtonStyle>

      <Form onSubmit={onSubmit} style={{ padding: '24px 0' }}>
        <TextField
          sx={{ m: 1, width: '30ch' }}
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          margin="normal"
          label="Enter email address"
          variant="standard"
        />
        <Button
          variant="outlined"
          sx={{ mt: 2 }}
          onClick={addEmail}
          disabled={!userEmail}
        >
          Add
        </Button>

        {/* Email List */}
        {emailList.length > 0 && (
          <div style={{ marginTop: '10px' }}>
            {emailList.map((email, index) => (
              <div
                key={`${index + 1}`}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
                <span style={{ fontSize: '13px' }}>{email}</span>
                <Button color="error" onClick={() => removeEmail(email)}>
                  Remove
                </Button>
              </div>
            ))}
          </div>
        )}

        <DialogActions>
          <Button onClick={onClose} color="primary" variant="contained">
            Cancel
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={emailList.length === 0}
          >
            Send
          </Button>
        </DialogActions>
      </Form>
    </StyledDialog>
  );
}

ScrollDialog.propTypes = {
  openDailog: PropTypes.bool,
  tId: PropTypes.string,
  onOpen: PropTypes.func,
  setSnackbarData: PropTypes.func,
  reportType: PropTypes.string,
};

ScrollDialog.defaultProps = {
  openDailog: false,
  tId: '',
  reportType: '',
  onOpen: PropTypes.func,
  setSnackbarData: PropTypes.func,
};
